import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { BACKSPACE, DOWN, UP } from '@wordpress/keycodes';
import { Component, createRef } from '@wordpress/element';
import classnames from 'classnames';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import Tags from './tags';
/**
 * A search control to allow user input to filter the options.
 */

var Control =
/*#__PURE__*/
function (_Component) {
  _inherits(Control, _Component);

  function Control(props) {
    var _this;

    _classCallCheck(this, Control);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Control).call(this, props));
    _this.state = {
      isActive: false
    };
    _this.input = createRef();
    _this.updateSearch = _this.updateSearch.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Control, [{
    key: "updateSearch",
    value: function updateSearch(onSearch) {
      return function (event) {
        onSearch(event.target.value);
      };
    }
  }, {
    key: "onFocus",
    value: function onFocus(onSearch) {
      var _this2 = this;

      var _this$props = this.props,
          isSearchable = _this$props.isSearchable,
          setExpanded = _this$props.setExpanded;
      return function (event) {
        _this2.setState({
          isActive: true
        });

        if (isSearchable) {
          onSearch(event.target.value);
        } else {
          setExpanded(true);
        }
      };
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.setState({
        isActive: false
      });
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var _this$props2 = this.props,
          decrementSelectedIndex = _this$props2.decrementSelectedIndex,
          incrementSelectedIndex = _this$props2.incrementSelectedIndex,
          selected = _this$props2.selected,
          onChange = _this$props2.onChange,
          query = _this$props2.query,
          setExpanded = _this$props2.setExpanded;

      if (BACKSPACE === event.keyCode && !query && selected.length) {
        onChange(_toConsumableArray(selected.slice(0, -1)));
      }

      if (DOWN === event.keyCode) {
        incrementSelectedIndex();
        setExpanded(true);
        event.preventDefault();
        event.stopPropagation();
      }

      if (UP === event.keyCode) {
        decrementSelectedIndex();
        setExpanded(true);
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var _this$props3 = this.props,
          multiple = _this$props3.multiple,
          selected = _this$props3.selected;

      if (multiple || !selected.length) {
        return null;
      }

      return createElement("div", {
        className: "woocommerce-select-control__control-value"
      }, selected[0].label);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props4 = this.props,
          activeId = _this$props4.activeId,
          hasTags = _this$props4.hasTags,
          inlineTags = _this$props4.inlineTags,
          instanceId = _this$props4.instanceId,
          isExpanded = _this$props4.isExpanded,
          isSearchable = _this$props4.isSearchable,
          listboxId = _this$props4.listboxId,
          onSearch = _this$props4.onSearch,
          placeholder = _this$props4.placeholder,
          searchInputType = _this$props4.searchInputType;
      var isActive = this.state.isActive;
      return createElement("input", {
        autoComplete: "off",
        className: "woocommerce-select-control__control-input",
        id: "woocommerce-select-control-".concat(instanceId, "__control-input"),
        ref: this.input,
        type: isSearchable ? searchInputType : 'button',
        value: this.getInputValue(),
        placeholder: isActive ? placeholder : '',
        onChange: this.updateSearch(onSearch),
        onFocus: this.onFocus(onSearch),
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        role: "combobox",
        "aria-autocomplete": "list",
        "aria-expanded": isExpanded,
        "aria-haspopup": "true",
        "aria-owns": listboxId,
        "aria-controls": listboxId,
        "aria-activedescendant": activeId,
        "aria-describedby": hasTags && inlineTags ? "search-inline-input-".concat(instanceId) : null
      });
    }
  }, {
    key: "getInputValue",
    value: function getInputValue() {
      var _this$props5 = this.props,
          isFocused = _this$props5.isFocused,
          isSearchable = _this$props5.isSearchable,
          multiple = _this$props5.multiple,
          query = _this$props5.query,
          selected = _this$props5.selected;
      var selectedValue = selected.length ? selected[0].label : ''; // Show the selected value for simple select dropdowns.

      if (!multiple && !isFocused) {
        return selectedValue;
      } // Show the search query when focused on searchable controls.


      if (isSearchable && isFocused) {
        return query;
      }

      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props6 = this.props,
          hasTags = _this$props6.hasTags,
          help = _this$props6.help,
          inlineTags = _this$props6.inlineTags,
          instanceId = _this$props6.instanceId,
          isSearchable = _this$props6.isSearchable,
          label = _this$props6.label,
          query = _this$props6.query;
      var isActive = this.state.isActive;
      return (// Disable reason: The div below visually simulates an input field. Its
        // child input is the actual input and responds accordingly to all keyboard
        // events, but click events need to be passed onto the child input. There
        // is no appropriate aria role for describing this situation, which is only
        // for the benefit of sighted users.

        /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
        createElement("div", {
          className: classnames('components-base-control', 'woocommerce-select-control__control', {
            empty: !query.length,
            'is-active': isActive,
            'has-tags': inlineTags && hasTags,
            'with-value': this.getInputValue().length
          }),
          onClick: function onClick() {
            _this3.input.current.focus();
          }
        }, isSearchable && createElement("i", {
          className: "material-icons-outlined"
        }, "search"), inlineTags && createElement(Tags, this.props), createElement("div", {
          className: "components-base-control__field"
        }, !!label && createElement("label", {
          htmlFor: "woocommerce-select-control-".concat(instanceId, "__control-input"),
          className: "components-base-control__label"
        }, label), this.renderInput(), inlineTags && createElement("span", {
          id: "search-inline-input-".concat(instanceId),
          className: "screen-reader-text"
        }, __('Move backward for selected items', 'woocommerce-admin')), !!help && createElement("p", {
          id: "woocommerce-select-control-".concat(instanceId, "__help"),
          className: "components-base-control__help"
        }, help)))
        /* eslint-enable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */

      );
    }
  }]);

  return Control;
}(Component);

Control.propTypes = {
  /**
   * Bool to determine if tags should be rendered.
   */
  hasTags: PropTypes.bool,

  /**
   * Help text to be appended beneath the input.
   */
  help: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Render tags inside input, otherwise render below input.
   */
  inlineTags: PropTypes.bool,

  /**
   * Allow the select options to be filtered by search input.
   */
  isSearchable: PropTypes.bool,

  /**
   * ID of the main SelectControl instance.
   */
  instanceId: PropTypes.number,

  /**
   * A label to use for the main input.
   */
  label: PropTypes.string,

  /**
   * ID used for a11y in the listbox.
   */
  listboxId: PropTypes.string,

  /**
   * Function called when selected results change, passed result list.
   */
  onChange: PropTypes.func,

  /**
   * Function called when input field is changed or focused.
   */
  onSearch: PropTypes.func,

  /**
   * A placeholder for the search input.
   */
  placeholder: PropTypes.string,

  /**
   * Search query entered by user.
   */
  query: PropTypes.string,

  /**
   * An array of objects describing selected values. If the label of the selected
   * value is omitted, the Tag of that value will not be rendered inside the
   * search box.
   */
  selected: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    label: PropTypes.string
  }))
};
export default Control;
//# sourceMappingURL=control.js.map